<template>
	<Card>
		<div class="yl-flex">
			<div class="yl-flex" style="width: 380px">
				<Input v-model="name" style="width: 250px" placeholder="请输入名称">
					<i-button slot="append" icon="ios-search"></i-button>
				</Input>
				<Button class='ivu-btn-circle' type="primary" @click="search">搜索</Button>
				<Button class='ivu-btn-circle' @click="initSearch">重置</Button>
			</div>
			<Button class='ivu-btn-circle' type="primary" @click="addBrandManage">新增品牌负责人</Button>
		</div>
		<div style="margin-top: 20px;">
			<Table size="small" :columns="columns" :data="data">
				<template slot-scope="{row}" slot="action">
					<Button class='ivu-btn-circle' :data-id="row.id" @click="editCharge" type="warning" size="small">
						编辑
					</Button>
					<Button class='ivu-btn-circle' :data-id="row.id" @click="delCharge" style="margin-left: 10px"
							size="small">删除
					</Button>
				</template>
			</Table>
			<div class="pager">
				<Page :total="count" :page-size="20" :current="page" @on-change="changePage"
					  size="small" show-total show-elevator/>
			</div>
		</div>
		<!-- 新增媒体代码 -->
		<Modal v-model="modal" width="700">
			<div class="add_flex">
				<div class="add_title">品牌负责人</div>
				<Input v-model="brandManageForm.name" style="width: 200px" placeholder="请输入品牌负责人姓名"/>
			</div>
			<div class="add_flex">
				<div class="add_title">关联老系统渠道</div>
				<Select v-model="brandManageForm.client_id" multiple>
					<Option v-for="item in clientIdList" :value="item.id" :key="item.id">{{item.username }}-[{{item.id}}]
					</Option>
				</Select>
			</div>
			<div class="add_flex">
				<div class="add_title">手机号码</div>
				<Input v-model="brandManageForm.phone" style="width: 200px" placeholder="请输入手机号码"/>
			</div>
			<div class="add_flex">
				<div class="add_title">备注</div>
				<Input v-model="brandManageForm.ext_info.remark" type="textarea" style="width: 300px" placeholder="请输入备注信息"/>
			</div>
			<div slot="footer">
				<Button type="primary" @click="save()">保存</Button>
			</div>
		</Modal>
	</Card>
</template>

<script>
	import {getChargeList, saveCharge, getCharge, delCharge} from '@/api/runSet';
	import {getClientIdList} from "../../api/finance";
	import {mapGetters, mapActions} from "vuex";

	export default {
		name: "BrandManage",
		components: {},
		computed:{
			...mapGetters(['userInfo', 'token']),
		},
		created(){
			this.loadData();
			this.getList();
		},
		data() {
			return {
				count: 0,
				page: 1,
				brandManageForm: {
					name: '',
					phone: '',
					client_id:'',
					ext_info: {remark: ''}
				},
				clientIdList:[],
				modal: false,
				name: '',
				columns: [{
					title: '品牌负责人',
					key: 'name'
				},
					{
						title: '登录账号',
						key: 'phone'
					},
					{
						title: '管理老系统id',
						key: 'clientid_name'
					},
					{
						title: '备注',
						key: 'remark'
					},
					{
						title: '操作',
						slot: 'action'
					},
				],
				data: [{
					brand_manage: '融汇网李总',
					phone: '15856565656',
					login_ID: '15856565656',
					remark: '代理北京，上海等城市',
				}]
			}
		},
		methods: {
			...mapActions([
				'handleLogOut',
			]),
			search() {
				this.page = 1;
				this.getList();
			},
			initSearch() {
				this.name = '';
				this.page = 1;
			},
			changePage(e) {
				this.page = e;
				this.getList();
			},
			async loadData() {
				let that = this;
				let data = {}
				data.token = this.token;
				let res = await getClientIdList(that, data);
				that.clientIdList = res.data.list;
			},
			// 新增品牌负责人
			addBrandManage() {
				this.initFormData();
				this.modal = true
			},
			async getList() {
				let that = this;
				let data = {token: that.token, page: this.page, name: this.name};
				let res = await getChargeList(that, data);
				if (res.code == 1) {
					that.data = res.data.list;
					that.count = res.count;
				}
			},
			save() {
				let that = this;
				this.throttle(async function() {
					let data = {token: that.token, data: that.brandManageForm};
					let res = await saveCharge(that, data);
					if (res.code == 1) {
						that.$Message.success(res.msg);
						that.modal = false;
						that.initFormData();
						that.getList();
					}
				}, 500)
			},
			initFormData() {
				this.brandManageForm = {
					name: '',
					phone: '',
					ext_info: {remark: ''}
				};
			},
			async editCharge(e) {
				let that = this;
				let id = e.currentTarget.dataset.id;
				let data = {token: that.token, id: id};
				let res = await getCharge(that, data);
				if (res.code == 1) {
					that.brandManageForm = res.data.item;
					that.modal = true;
				}
			},
			delCharge(e) {
				let that = this;
				let id = e.currentTarget.dataset.id;
				that.$Modal.confirm({
					title: '确认删除吗？',
					onOk: async() => {
						that.throttle(async function () {
							let data = {token: that.token, id: id}
							let res = await delCharge(that, data);
							if (res.code == 1) {
								that.$Message.success('删除成功');
								that.getList();
							}
						}, 1000);
					}
				})
			},
		}
	}
</script>

<style scoped lang="less">
	.yl-flex {
		display: flex;
		justify-content: space-between;
		padding-bottom: 0;
	}

	.add_flex {
		display: flex;
		align-items: center;
		margin: 10px 0;
	}

	.add_title {
		margin: 0 10px;
		font-weight: bold;
		width: 80px;

	}
</style>
